import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal
} from '@angular/core';
import { firstPageDefault, pageSizeOptions } from "../../../../../core/models/pagination-params";
import { ValidationService } from "../../../../../core/services/validation.service";
import { ErrorService } from "../../../../../core/services/error.service";
import { MatPaginator, MatPaginatorIntl, PageEvent } from "@angular/material/paginator";
import { CustomPaginatorIntl } from "../../../../../core/models/custom-paginator-intl";
import {
  DailyFeedbackReportsPaginationDataService
} from "../../services/daily-feedback-reports-pagination-data.service";
import { DailyFeedbackReportsPagination } from "../../types/daily-feedback-reports-page.types";
import { NumberInputParams } from "../../../../../core/types/number-input.types";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-daily-feedback-reports-page-pagination',
  standalone: true,
  templateUrl: './daily-feedback-reports-page-pagination.component.html',
  styleUrl: './daily-feedback-reports-page-pagination.component.scss',
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }
  ],
  imports: [
    FormsModule,
    MatPaginator
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DailyFeedbackReportsPagePaginationComponent {
  dailyFeedbackReportsPaginationData = input.required<DailyFeedbackReportsPagination>();
  selectedPage = output<void>();

  private dailyFeedbackReportsPaginationDataService: DailyFeedbackReportsPaginationDataService = inject(DailyFeedbackReportsPaginationDataService);
  private validationService: ValidationService = inject(ValidationService);
  private errorService: ErrorService = inject(ErrorService);

  public pageSizeOptions = signal<Array<number>>(pageSizeOptions);
  public firstPage = signal<number>(firstPageDefault);
  public selectTablePage = signal<number>(firstPageDefault);

  public goToPage(page: number | string): void {
    this.selectTablePage.set(Number(page));
    this.dailyFeedbackReportsPaginationDataService.goToPage(this.selectTablePage());
    this.selectedPage.emit();
  }

  public preventDecimalInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const numberInputConfig = this.getNumberInputConfig(value);

    if (this.validationService.isInvalidNumberInput(numberInputConfig)) {
      this.errorService.showErrorMessage(`Ошибка! Укажите целое число от ${this.firstPage()} до ${this.dailyFeedbackReportsPaginationData().totalPages}.`);
      input.value = ((this.dailyFeedbackReportsPaginationData().number || 0) + 1).toString();
    }
  }

  public preventInvalidNumericInput(event: KeyboardEvent) {
    this.validationService.preventInvalidNumericInput(event);
  }

  public changePageParams(event: PageEvent): void {
    this.selectTablePage.set(event.pageIndex + 1);
    this.dailyFeedbackReportsPaginationDataService.updatePaginationProps(event);
    this.selectedPage.emit();
  }

  private getNumberInputConfig(value: string): NumberInputParams {
    return {
      value,
      minValue: this.firstPage(),
      maxValue: this.dailyFeedbackReportsPaginationData().totalPages
    };
  }
}
